// "Manage Organization" used to live only in redux, so a page refresh dropped an
// internal admin back into the organization encoded in their Cognito token. We keep
// the selection here instead.
//
// sessionStorage rather than localStorage, deliberately: the selection stays scoped to
// one tab, so support staff can keep several organizations open side by side, and a
// closed browser falls back to the admin's own organization. It is also stored against
// the cognitoSub so a different account can never inherit a selection.
const STORAGE_KEY = 'civicChamps.managedOrgOverride'

export const readManagedOrgOverride = cognitoSub => {
  if (!cognitoSub) return null

  try {
    const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY))
    if (!stored || stored.cognitoSub !== cognitoSub) return null

    const organizationId = Number(stored.organizationId)
    return Number.isFinite(organizationId) ? organizationId : null
  } catch (error) {
    return null
  }
}

export const saveManagedOrgOverride = (cognitoSub, organizationId) => {
  if (!cognitoSub || organizationId == null) return

  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ cognitoSub, organizationId: Number(organizationId) }))
  } catch (error) {
    // Storage can be unavailable (private mode, quota). Losing the selection on
    // refresh is the old behaviour, so there is nothing to recover from here.
  }
}

export const clearManagedOrgOverride = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch (error) {
    // See saveManagedOrgOverride.
  }
}
